import React, { useState } from 'react';
import OperationCard from '../molecules/OperationCard';
import OperationCancelModal from '../molecules/OperationCancelModal';
import { OperationHeader } from '../molecules/ContentHeader';

import { useHistory } from 'react-router-dom';
import { hasContracts } from '../search-api/search-api-client';
import MessageModal from '../molecules/MessageModal';
import moment from 'moment';
import { ifBasePath, defaultProjectId } from '../../config/baseConfig';
import Redux from '../../redux/ReduxConnector';
import LocalStorage, { LocalStorageKey } from '../../utils/LocalStorage';
import { CircularProgress } from '@material-ui/core';
import { BasicItemKeys } from '../../enums/item/basic-item-keys';
import { useSearchIndex } from '../../hooks/useSearchIndex';

const OperationTemplate: React.FC = () => {
  const history = useHistory();

  const index = useSearchIndex();

  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const [spaceContractData, setSpaceContractData] = React.useState<any>(undefined);
  const [progress, setProgress] = React.useState(false);

  // バリデーションエラー用
  const [open, setOpen] = React.useState<boolean>(false);

  // 通信エラー用
  const [isError, setIsError] = React.useState<boolean>(false);
  const detectError = React.useCallback(() => setIsError(true), [setIsError]);
  const resetError = React.useCallback(() => setIsError(false), [setIsError]);

  const handleTerminate = React.useCallback(() => {
    const params = new URLSearchParams(history.location.search);
    const allSpaceId = params.get('s') || '';
    const contractId = params.get('c') || '';
    history.push(`/terminate?s=${allSpaceId}&c=${contractId}`);
  }, [history]);

  const cancelContract = React.useCallback(
    (e: any) => {
      setIsError(false);
      setIsCancelModalOpen(true);
    },
    [setIsCancelModalOpen, setIsError]
  );

  React.useEffect(() => {
    setProgress(true);
    const params = new URLSearchParams(history.location.search);
    const allSpaceId = params.get('s') || '';
    const contractId = params.get('c') || '';
    fetch(`${ifBasePath}project/${defaultProjectId}/application/origin/${allSpaceId}/${contractId}`, {
      method: 'POST',
      headers: {
        'x-api-key': Redux.getStore().user.accessToken || LocalStorage.get(LocalStorageKey.ACCESS_TOKEN) || '',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        refresh_token: Redux.getStore().user.refreshToken || LocalStorage.get(LocalStorageKey.REFRESH_TOKEN)
      })
    })
      .then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        index
          .search({
            filters: {
              'sumamoruData.sumamoruLinkable': ['true'],
              id: [allSpaceId]
            },
            excludeFilters: {},
            length: 1000,
            offset: 0
          })
          .then(res => {
            setProgress(false);
            const result = res.hits
              .filter(hasContracts)
              .map(hit =>
                hit.sumamoruData.contracts.map(contract => ({
                  base: hit,
                  sumamoruData: hit.sumamoruData,
                  contract: contract
                }))
              )
              .reduce((a, b) => a.concat(b), [] as any[])
              .filter(hit => hit.contract.contractId === contractId);
            setSpaceContractData({ ...data, ...result[0] });
            index.clearCache();
          })
          .catch(() => {
            setProgress(false);
          });
      })
      .catch(e => {
        console.log(e);
        setProgress(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.search, setSpaceContractData]);

  return (
    <>
      <OperationHeader
        setIsModalOpen={cancelContract}
        all_space_id={spaceContractData && spaceContractData[BasicItemKeys.AllSpaceId]}
        contract_id={spaceContractData && spaceContractData[BasicItemKeys.ContractId]}
        handleTerminate={handleTerminate}
        isError={isError}
        errorMessage={'連携に失敗しました。'}
      />
      <OperationCard spaceContractData={spaceContractData} detectError={detectError} resetError={resetError} />
      <OperationCancelModal
        isOpen={isCancelModalOpen}
        isOverContractDate={
          spaceContractData &&
          !moment().isBefore(
            spaceContractData[BasicItemKeys.HasElectricContract]
              ? spaceContractData[BasicItemKeys.ElectricityStartDate]
              : spaceContractData[BasicItemKeys.OccupyScheduledDate]
          )
        }
        setIsOpen={e => setIsCancelModalOpen(e)}
        all_space_id={spaceContractData && spaceContractData[BasicItemKeys.AllSpaceId]}
        contract_id={spaceContractData && spaceContractData[BasicItemKeys.ContractId]}
        has_electric_contract={spaceContractData && spaceContractData[BasicItemKeys.HasElectricContract]}
        detectError={detectError}
      />
      {/* バリデーションエラー */}
      <MessageModal
        key={'errorMessage'}
        isOpen={open}
        setIsOpen={setOpen}
        title={'エラー'}
        message={['このデータはすでに解約処理が行われています。', 'もう一度処理を実行することはできません。']}
      />
      {progress && (
        <div>
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default OperationTemplate;
